import styled from 'styled-components'

export const AbasGrid = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 2px dashed #d9d9d9;
  position: relative;
  padding-bottom: 5px;

  .aba__pontos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px;
    width: 50%;

    span {
      font-size: 13px;
      color: black;
    }
  }

  .aba__ordenacao {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px;
    width: 50%;

    span {
      font-size: 13px;
      color: black;
    }
  }

  .aba__map {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px;
    width: 50%;

    span {
      font-size: 13px;
      color: black;
    }
  }

  .abas__icones {
    color: black;
    font-size: 15;
  }

  .aba__map:is([data-open='Mapa']) {
    transition: 1.3s;
    background-color: #5da57d;

    .abas__icones {
      color: white;
    }

    span {
      color: white;
    }
  }

  .aba__pontos:is([data-open='Pontos']) {
    background-color: #5da57d;
    transition: 1.2s;

    .abas__icones {
      color: white;
    }

    span {
      color: white;
    }
  }

  .aba__ordenacao:is([data-open='Ordenacao']) {
    background-color: #5da57d;
    transition: 1.2s;

    .abas__icones {
      color: white;
    }

    span {
      color: white;
    }
  }

  .indicador {
    width: 30%;
    background-color: #5da57d;
    height: 2px;
    border-radius: 10px;
    position: absolute;
  }

  .indicador:is([data-open='Pontos']) {
    transform: translate(115%);
    transition: 0.5s;
  }

  .indicador:is([data-open='Ordenacao']) {
    transform: translate(227%);
    transition: 0.5s;
  }

  .indicador:is([data-open='Mapa']) {
    transform: translate(5%);
    transition: 0.5s;
  }

  .aba__map:is([data-mostrar='true']) {
    opacity: 0;
  }

  .indicador:is([data-mostrar='true']) {
    opacity: 0;
  }

  .aba__map:is([data-mostrar='false']) {
    opacity: 1;
  }

  .indicador:is([data-mostrar='false']) {
    opacity: 1;
  }
`
